<template>
  <ButtonPrimary
    :disabled="disabled"
    :label="label"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ButtonPrimary } from '@warrenbrasil/nebraska-web';

@Component({
  inheritAttrs: false,
  components: { ButtonPrimary }
})
export default class WealthChartAction extends Vue {
  @Prop({ type: String })
  private label?: string;

  @Prop({ type: Boolean, required: false })
  private disabled!: boolean;
}
</script>

<style lang="less" scoped>
.chart-action {
  display: inline-block;
}
</style>
